<script>import { toImageCdn } from "@infinitro/config";
import { Currency, FiatCurrency } from "@infinitro/global/wallet";
export let currency = Currency.btc;
export let is3d = false;
export let size = "30";
let src;
let loaded = false;
let triedFallback = false;
$: {
  loaded = false;
  triedFallback = false;
  if (is3d) {
    src = toImageCdn(`tokens/${currency.toLowerCase()}_3d.png`);
  } else {
    src = toImageCdn(`tokens/${currency.toLowerCase()}.svg`);
  }
}
function handleImageError(e) {
  const img = e.currentTarget;
  if (!triedFallback && src.endsWith(".svg")) {
    triedFallback = true;
    src = src.replace(".svg", ".png");
    return;
  }
  loaded = true;
  if (img) {
    img.onerror = null;
    img.style.display = "none";
  }
}
function handleImageLoad() {
  loaded = true;
}
</script>

<div style="position: relative; width: {size}px; height: {size}px; display: inline-block;">
	<!-- Skeleton placeholder while loading -->
	{#if !loaded}
		<div
			style="width: {size}px; height: {size}px; border-radius: 50%; background: linear-gradient(90deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.25) 50%, rgba(255,255,255,0.15) 100%); background-size: 200% 100%; animation: shimmer 1.5s infinite;"
			aria-hidden="true"
		/>
	{/if}

	<!-- Actual currency icon -->
	<img
		{src}
		alt={currency}
		style="width: {size}px; position: absolute; top: 0; left: 0; {loaded ? '' : 'opacity: 0;'}"
		on:error={handleImageError}
		on:load={handleImageLoad}
	/>
</div>

<style>
	@keyframes shimmer {
		0% {
			background-position: -200% 0;
		}
		100% {
			background-position: 200% 0;
		}
	}
</style>
